<template>
  <div class="agent-details-view ut-card-base ut-relative">
    <div class="ut-flex">
      <h2 class="ut-text-left ut-ml-0 subtitle">Your details</h2>
      <a
        class="ut-text-right ut-mr-0 ut-absolute ut-top-0 ut-right-0 ut-mt-6 ut-mr-6 ga-event"
        @click="editClicked"
        data-category="Contact Details">
        Edit
      </a>
    </div>
    <div v-if="agent" class="sm:ut-flex ut-justify-between">
      <!-- <h2 class="ut-text-left ut-ml-0 subtitle">Your details</h2> -->
      <ul class="ut-ml-0 ">
        <li>Name: <i>{{ agent.name }}</i></li>
        <li>Email: <i>{{ agent.email }}</i></li>
        <li>Personal email: <i>{{ agent.personalemail }}</i></li>
        <li>Phone number: <i>{{ agent.phone }}</i></li>
        <li>Agency: <i>{{ currentAgency }}</i></li>
      </ul>
      <figure class="ut-circle-img ut-h-32 ut-w-32 ut-bg-neutral-001 ut-mt-0 ut-mr-0">
        <img
          :src="agentProfileImage"
          alt="Agent profile photo"
          class="ut-flex-shrink-0"
        />
      </figure>
    </div>
    <div v-if="agent">
      <div class="ut-flex ut-justify-start ut-items-center">
        <h2 class="ut-text-left ut-mx-0 subtitle">Secondary contact details</h2>
        <span class="ut-rounded-full ut-w-5 ut-h-5 ut-border ut-mx-2 ut-text-center ut-cursor-pointer ut-leading-none"
            v-tooltip="{content: 'This is a second contact. For example your assistant or another agent who works with you.<br><br>This contact will also receive the weekly OpenAgent Open Leads Digest.', classes: ['info'], trigger: 'hover click'}">i</span>
      </div>
      <ul class="ut-ml-0 ">
        <li>Name: <i>{{ agent.secondaryname }}</i></li>
        <li>Email: <i>{{ agent.secondaryemail }}</i></li>
      </ul>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'UserDetailsView',
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    agentProfileImage() {
      if (this.agent && this.agent.imageurl) {
        return `${process.env.VUE_APP_CDN_URL}/img/agent/${this.agent.imageurl}`;
      }
      return require('../../assets/styles/frontend-library/images/user-solid-dark.svg');
    },
    currentAgency() {
      return this.agent && this.agent.agencyname
        ? this.agent.agencyname
        : '';
    },
  },
  methods: {
    editClicked() {
      this.$emit('edit-details');
    },
    // gaEvent(eventAction, eventLabel) {
    //   const label = `AID=${this.agent.id} | ${eventLabel || ''}`;
    //   return {
    //     category: 'AgentPortal',
    //     action: eventAction,
    //     label,
    //   };
    // },
  },
};

</script>

<style lang="scss" scoped>
  .agent-details-view {

    .subtitle {
      @apply ut-text-lg ut-font-bold ut-my-4;
      letter-spacing: -0.2px;
      line-height: 25px;
    }

    ul {
      li {
         @apply ut-my-4;
        color: #233A3A;

        i {
          @apply ut-opacity-60;
        }
      }
    }
  }

  a {
    @apply ut-block ut-underline ut-text-green-400;
  }

</style>
